import uniswapLogo from '../assets/uniswap 1.svg'
import avatar1 from '../assets/avatar1.svg'
import avatar2 from '../assets/avatar2.svg'
import avatar3 from '../assets/avatar3.svg'
import ethereumLogo from '../assets/ethereum 1.svg'
// import bgDashboard from ''

export const dashCardData = [
    {
      id: "1",
      iconnum: "8",
      label: "Active protocols insured",
      color: "#B6FEA4",
      bgimage: ""
    },
    {
      id: "2",
      iconnum: "4500.00 USDT",
      label: "Active Insurance cover amount",
      color: "#FCDF96",
      bgimage: ""
    },
    {
      id: "3",
      iconnum: "20,000.00 USDT",
      label: "Total amount staked",
      color: "#AFD9FF",
      bgimage: ""
    },

]


export const listedCover = [
   {
    id: "1",
    logo: uniswapLogo,
    logoname: "InstaDapp",
    subtile: "Smart contract vulnerability",
    totalAmount: "25,000.00 USDC",
    coverBought: "8,000.00 USDC",
    totalProfit: "1,500.00 USDC",
    dateCreated: "21/01/2023",
   },
   {
    id: "2",
    logo: uniswapLogo,
    logoname: "InstaDapp",
    subtile: "Smart contract vulnerability",
    totalAmount: "25,000.00 USDC",
    coverBought: "8,000.00 USDC",
    totalProfit: "1,500.00 USDC",
    dateCreated: "21/01/2023",
   },
   {
    id: "3",
    logo: uniswapLogo,
    logoname: "InstaDapp",
    subtile: "Smart contract vulnerability",
    totalAmount: "25,000.00 USDC",
    coverBought: "8,000.00 USDC",
    totalProfit: "1,500.00 USDC",
    dateCreated: "21/01/2023",
   },
   {
    id: "4",
    logo: uniswapLogo,
    logoname: "InstaDapp",
    subtile: "Smart contract vulnerability",
    totalAmount: "25,000.00 USDC",
    coverBought: "8,000.00 USDC",
    totalProfit: "1,500.00 USDC",
    dateCreated: "21/01/2023",
   },
]


export const memberList = [
  {
   id: "#001",
   address: "0x8b93...8b0F",
   balance: "12500 USDC",
   percentage: "0.281",
   voting: "0.0281",
  },
  {
    id: "#002",
    address: "0x8b93...8b0F",
    balance: "12500 USDC",
    percentage: "0.281",
    voting: "0.0281",
   },
   {
    id: "#003",
    address: "0x8b93...8b0F",
    balance: "12500 USDC",
    percentage: "0.281",
    voting: "0.0281",
   },
]



export const votersList = [
  {
   id: "1",
   address: "0x8b93...8b0F",
   avatar: avatar1,
   votedecision: "Yes",
   ensname: "#bafkrei",
  },
  {
    id: "2",
    address: "0x8b93...8b0F",
    votedecision: "Yes",
    avatar: avatar2,
    ensname: "#bafkrei",
   },
   {
    id: "3",
    address: "0x8b93...8b0F",
    votedecision: "Yes",
    avatar: avatar3,
    ensname: "#bafkrei",
   },
   {
    id: "3",
    address: "0x8b93...8b0F",
    votedecision: "Yes",
    avatar: avatar2,
    ensname: "#bafkrei",
   },
   {
    id: "4",
    address: "0x8b93...8b0F",
    votedecision: "Yes",
    avatar: avatar3,
    ensname: "#bafkrei",
   },
]

export const myInsureCover = [
  {
   id: "1",
   logo: uniswapLogo,
   logo2: ethereumLogo,
   logoname: "InstaDapp",
   subtile: "Smart contract vulnerability",
   chains: "ethereum",
   coveredAddress: "0x8b93...8b0F",
   coveredPeriod: "21/01/2023 - 30/05/2023",
  },
  {
   id: "2",
   logo: uniswapLogo,
   logo2: ethereumLogo,
   logoname: "InstaDapp",
   subtile: "Smart contract vulnerability",
   chains: "ethereum",
   coveredAddress: "0x8b93...8b0F",
   coveredPeriod: "21/01/2023 - 30/05/2023",
  },
  {
   id: "3",
   logo: uniswapLogo,
   logo2: ethereumLogo,
   logoname: "InstaDapp",
   subtile: "Smart contract vulnerability",
   chains: "ethereum",
   coveredAddress: "0x8b93...8b0F",
   coveredPeriod: "21/01/2023 - 30/05/2023",
  },
  {
   id: "4",
   logo: uniswapLogo,
   logo2: ethereumLogo,
   logoname: "InstaDapp",
   subtile: "Smart contract vulnerability",
   chains: "ethereum",
   coveredAddress: "0x8b93...8b0F",
   coveredPeriod: "21/01/2023 - 30/05/2023",
  },
]


export const myInsureClaim = [
  {
   id: "1",
   logo: uniswapLogo,
   logo2: ethereumLogo,
   chainId: "001",
   logoname: "InstaDapp",
   subtile: "Smart contract vulnerability",
   chains: "ethereum",
   claimAmount: "2,000.000 USDT",
   button1: "In Progress"
  },
  {
   id: "2",
   logo: uniswapLogo,
   logo2: ethereumLogo,
   chainId: "002",
   logoname: "InstaDapp",
   subtile: "Smart contract vulnerability",
   chains: "ethereum",
   claimAmount: "2,000.000 USDT",
   button1: "In Progress"
  },
  {
   id: "3",
   logo: uniswapLogo,
   logo2: ethereumLogo,
   chainId: "003",
   logoname: "InstaDapp",
   subtile: "Smart contract vulnerability",
   chains: "ethereum",
   claimAmount: "2,000.000 USDT",
   button2: "Completed"
  },
  {
   id: "4",
   logo: uniswapLogo,
   logo2: ethereumLogo,
   chainId: "004",
   logoname: "InstaDapp",
   subtile: "Smart contract vulnerability",
   chains: "ethereum",
   claimAmount: "2,000.000 USDT",
   button3: "Rejected"
  },
]